"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverMenu = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const popover_menu_style_1 = __importDefault(require("./popover.menu.style"));
const veneer_1 = __importDefault(require("../veneer/veneer"));
class PopoverMenu extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.getPosition = () => {
            const { width, height, left, top } = this.props.button.getBoundingClientRect();
            const right = window.innerWidth - left - width;
            const bottom = window.innerHeight - top - height;
            const position = {};
            if (left < right) {
                position.left = left;
            }
            else {
                position.right = right;
            }
            if (bottom < top) {
                position.bottom = window.innerHeight - top;
            }
            else {
                position.top = top + height;
            }
            return position;
        };
        this.render = () => {
            const { classes, children, handleCollapse } = this.props;
            const veneerProps = {
                handleCollapse,
                invisible: true,
                contentPosition: this.getPosition()
            };
            const menuProps = {
                role: 'menu',
                tabIndex: 0,
                className: classes.menu,
                onClick: handleCollapse
            };
            return (jsx_runtime_1.jsx(veneer_1.default, Object.assign({}, veneerProps, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.root }, { children: jsx_runtime_1.jsx("ul", Object.assign({}, menuProps, { children: children }), void 0) }), void 0) }), void 0));
        };
    }
}
exports.PopoverMenu = PopoverMenu;
PopoverMenu.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    handleCollapse: prop_types_1.default.func.isRequired,
    button: prop_types_1.default.object.isRequired
};
exports.default = react_jss_1.default(popover_menu_style_1.default)(PopoverMenu);
//# sourceMappingURL=popover.menu.js.map